import {AbstractFindAllService} from '../../../../../core/service/v2/service/findAll/abstractFindAll.service';
import {AgendaCategoryHolder} from '../entity/agendaCategoryHolder';
import {AbstractRepositoryV2} from '../../../../../core/service/v2/abstractRepositoryV2';
import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {
    AbstractDataServiceAdapter
} from '../../../../../core/service/v2/dataservice/adapter/abstractDataService.adapter';

export abstract class AgendaCategoryHolderFindAllService<StoredEntity, Entity extends AgendaCategoryHolder>
    extends AbstractFindAllService<StoredEntity, Entity>{

    protected constructor(
        repository: AbstractRepositoryV2<StoredEntity>,
        dataServiceAdapter: AbstractDataServiceAdapter<StoredEntity, Entity, HttpModelConverter<Entity>>) {
        super(repository, dataServiceAdapter);
    }
}
